import React from 'react';
import styles from './SectionInfo.module.css';
import store from"../../../assets/store.png";
import location from"../../../assets/location.png";
import trust from"../../../assets/trust.png";
const cardsData = [
  {
    id: 1,
    icon: store,
    title: 'Shop Local',
    description: 'Support local and small businesses',
  },
  {
    id: 2,
    icon: location,
    title: 'Find Nearby',
    description: "See what's available near you",
  },
  {
    id: 3,
    icon: trust,
    title: 'Trusted Community',
    description: 'Verified sellers and trusted services',
  },
];

export const SectionInfo = () => {
  return (
    <section className={styles.quickInfoSection}>
      <div className={styles.container}>
        <div className={styles.cardsGrid}>
          {cardsData.map(card => (
            <div key={card.id} className={styles.card}>
              <div className={styles.cardIcon}><img src={card.icon} alt={card.title}  style={{width: '100%', height: '100%', maxWidth:"50px", objectFit: 'cover'}}/></div>
              <div className="">
                  <h3 className={styles.cardTitle}>{card.title}</h3>
                  <p className={styles.cardDescription}>{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionInfo;
